import { render, staticRenderFns } from "./OwnerAboutYou.vue?vue&type=template&id=c048c9ac&scoped=true"
import script from "./OwnerAboutYou.vue?vue&type=script&lang=js"
export * from "./OwnerAboutYou.vue?vue&type=script&lang=js"
import style0 from "./OwnerAboutYou.vue?vue&type=style&index=0&id=c048c9ac&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c048c9ac",
  null
  
)

export default component.exports